import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { localize2WithPath } from 'vscode/vscode/vs/nls';
import { AccessibilitySignal } from 'vscode/vscode/vs/platform/accessibilitySignal/browser/accessibilitySignalService';
import { IAccessibilitySignalService } from 'vscode/vscode/vs/platform/accessibilitySignal/browser/accessibilitySignalService.service';
import { registerAction2, Action2, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { ActiveEditorContext } from 'vscode/vscode/vs/workbench/common/contextkeys';
import { CHAT_CATEGORY, isChatViewTitleActionContext } from 'vscode/vscode/vs/workbench/contrib/chat/browser/actions/chatActions';
import { clearChatEditor } from './chatClear.js';
import { CHAT_VIEW_ID } from 'vscode/vscode/vs/workbench/contrib/chat/browser/chat';
import { IChatWidgetService } from 'vscode/vscode/vs/workbench/contrib/chat/browser/chat.service';
import { ChatEditorInput } from 'vscode/vscode/vs/workbench/contrib/chat/browser/chatEditorInput';
import { CONTEXT_CHAT_ENABLED, CONTEXT_IN_CHAT_SESSION } from 'vscode/vscode/vs/workbench/contrib/chat/common/chatContextKeys';

const _moduleId = "vs/workbench/contrib/chat/browser/actions/chatClearActions";
const ACTION_ID_NEW_CHAT = `workbench.action.chat.newChat`;
function registerNewChatActions() {
    registerAction2(class NewChatEditorAction extends Action2 {
        constructor() {
            super({
                id: 'workbench.action.chatEditor.newChat',
                title: ( localize2WithPath(_moduleId, 0, "New Chat")),
                icon: Codicon.plus,
                f1: false,
                precondition: CONTEXT_CHAT_ENABLED,
                menu: [{
                        id: MenuId.EditorTitle,
                        group: 'navigation',
                        order: 0,
                        when: ( (ActiveEditorContext.isEqualTo(ChatEditorInput.EditorID))),
                    }]
            });
        }
        async run(accessor, ...args) {
            announceChatCleared(accessor);
            await clearChatEditor(accessor);
        }
    });
    registerAction2(class GlobalClearChatAction extends Action2 {
        constructor() {
            super({
                id: ACTION_ID_NEW_CHAT,
                title: ( localize2WithPath(_moduleId, 0, "New Chat")),
                category: CHAT_CATEGORY,
                icon: Codicon.plus,
                precondition: CONTEXT_CHAT_ENABLED,
                f1: true,
                keybinding: {
                    weight: 200 ,
                    primary: 2048  | 42 ,
                    mac: {
                        primary: 256  | 42
                    },
                    when: CONTEXT_IN_CHAT_SESSION
                },
                menu: [{
                        id: MenuId.ChatContext,
                        group: 'z_clear'
                    },
                    {
                        id: MenuId.ViewTitle,
                        when: ( (ContextKeyExpr.equals('view', CHAT_VIEW_ID))),
                        group: 'navigation',
                        order: -1
                    }]
            });
        }
        run(accessor, ...args) {
            const context = args[0];
            if (isChatViewTitleActionContext(context)) {
                announceChatCleared(accessor);
                context.chatView.clear();
                context.chatView.widget.focusInput();
            }
            else {
                const widgetService = accessor.get(IChatWidgetService);
                const widget = widgetService.lastFocusedWidget;
                if (!widget) {
                    return;
                }
                announceChatCleared(accessor);
                widget.clear();
                widget.focusInput();
            }
        }
    });
}
function announceChatCleared(accessor) {
    accessor.get(IAccessibilitySignalService).playSignal(AccessibilitySignal.clear);
}

export { ACTION_ID_NEW_CHAT, registerNewChatActions };
